// extracted by mini-css-extract-plugin
export default {"container":"SendActionCard_container__9Bu6e","bg":"SendActionCard_bg__omc66","item_dets":"SendActionCard_item_dets__kKUlr"};